// NOVALUE1 (docs/build-briefs/NOVALUE1-no-na-no-utc.md; design/style-guide.md, "Blank, never N/A" and "No technical labels"):
// the one place a calendar day or an instant becomes "Oct 21, 2026" or "Oct 21, 2026, 3:42 PM". People never see an ISO date
// or UTC. Moved here unchanged in behavior from franchisorLocationsModel.ts (still re-exported from there) so the location
// and Snip & Sip Admin consoles use the same formatter as the franchisor console.

export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] as const;

/** "2026-10-21" -> "Oct 21, 2026". No locale, no zone: the date is the network's own. Blank for null. */
export function usDate(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (match === null) return "";
  const name = MONTH_NAMES[Number(match[2]) - 1];
  return name === undefined ? "" : `${name} ${Number(match[3])}, ${match[1]}`;
}

/** "Oct 21, 2026, 3:42 PM" in the location's own zone, never UTC. Blank when there is no sale or the zone is unreadable. */
export function localTimeText(instant: string | null, timeZone: string): string {
  if (instant === null) return "";
  const when = new Date(instant);
  if (Number.isNaN(when.getTime())) return "";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone,
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    }).format(when);
  } catch (error) {
    if (error instanceof RangeError) return "";
    throw error;
  }
}

